import {h, Fragment} from "preact"
import { getColorSwatchSrc } from "../../helpers";

export default function Swatch({ value, selected, onChange, className }) {
    const imageSrc = getColorSwatchSrc(value.toLowerCase(), '24x');

    return (
        <label className={`ns-swatch ns-d-block ns-color ${className} ${selected ? 'active' : ''}`} tabIndex={ `${ selected ? 0 : -1}` } role="radio" aria-label={`${"color-"+value.toLowerCase().replace(/\s+/g, '-')}`} aria-checked={ `${ selected ? true : false }` }>
            <input type="checkbox" checked={selected} onChange={onChange} />
            <span class="ns-swatch-checkbox" style={{ backgroundImage: `url(${imageSrc})` }}></span>
        </label>
    )
}